module.exports = {
  NODE_ENV: '"production"'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 219
// module chunks = 1